<template>
  <VContainer>
    <VRow justify="center">
      <VCol cols="12" md="8">
        <VCard elevation="1" class="pa-3 pa-md-7 px-md-12 mb-5">
          <!-- <EnConfidential /> -->
          <Component :is="localizedComponent" />
        </VCard>
      </VCol>
    </VRow>
  </VContainer>
</template>

<script>
import RuConfidential from './RuConfidential.vue';
import EnConfidential from './EnConfidential.vue';

export default {
  name: 'Confidential',
  components: {
    RuConfidential,
    EnConfidential,
  },
  computed: {
    localizedComponent() {
      if (this.$i18n.locale === 'ru') {
        return 'RuConfidential';
      }
      return 'EnConfidential';
    },
  },
  mounted() {
    this.$nextTick(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  },
};
</script>
